"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var common_1 = require("@angular/common");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var Observable_1 = require("rxjs/Observable");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var sso_config_1 = require("../modules/sso-pre-login/sso-config");
var login_status_enum_1 = require("../provider/enums/login-status.enum");
var LoginService = /** @class */ (function () {
    function LoginService(router, authenticationService, messageService, applicationPropertiesService, platformLocation) {
        this.router = router;
        this.authenticationService = authenticationService;
        this.messageService = messageService;
        this.applicationPropertiesService = applicationPropertiesService;
        this.platformLocation = platformLocation;
        // Should not be subscribed inside of service, this should be fixed later
        this._openSubscriptions = [];
        this._loginRequestState = null;
    }
    LoginService_1 = LoginService;
    LoginService.prototype.login = function (username, password, properties) {
        return this.loginOrGetErrorMessage(username, password, properties)
            .then(function () { return true; })
            .catch(function () { return false; });
    };
    LoginService.prototype.loginOrGetErrorMessage = function (username, password, properties) {
        var _this = this;
        if (this._loginRequestState === null) {
            this._loginRequestState = new Promise(function (resolve, reject) {
                _this.authenticationService
                    .login(username, password)
                    .map(function (login) {
                    switch (login.loginResponse) {
                        case idm_authentication_client_js_1.LoginResponseType.SUCCESS:
                            if (properties && properties.doNotRedirectOnSuccess) {
                                _this.resetLoginRequestState();
                                resolve({
                                    loginStatus: login_status_enum_1.LoginStatus.SUCCESS,
                                    message: null,
                                    data: null
                                });
                            }
                            else {
                                _this.router.navigateByUrl(_this.authenticationService.redirectUrl).then(function () {
                                    _this.resetLoginRequestState();
                                    resolve({
                                        loginStatus: login_status_enum_1.LoginStatus.SUCCESS,
                                        message: null,
                                        data: null
                                    });
                                });
                            }
                            break;
                        case idm_authentication_client_js_1.LoginResponseType.EXPIRED:
                            _this.router.navigate(['/expiredpassword', username]).then(function () {
                                _this.resetLoginRequestState();
                                reject({
                                    loginStatus: login_status_enum_1.LoginStatus.EXPIRED,
                                    message: '',
                                    data: null
                                });
                            });
                            break;
                        case idm_authentication_client_js_1.LoginResponseType.NEED_VERIFICATION:
                            _this._openSubscriptions.push(_this.messageService.getMessage(LoginService_1.VERIFICATION_MESSAGE).subscribe(function (message) {
                                _this.resetLoginRequestState();
                                reject({
                                    loginStatus: login_status_enum_1.LoginStatus.NEED_VERIFICATION,
                                    message: login.verificationType,
                                    data: null
                                });
                            }));
                            break;
                        case idm_authentication_client_js_1.LoginResponseType.BLOCK:
                            _this._openSubscriptions.push(_this.messageService
                                .getMessageWithPlaceholder(login.messageId, login.placeholders)
                                .subscribe(function (message) {
                                _this.resetLoginRequestState();
                                reject({
                                    loginStatus: login_status_enum_1.LoginStatus.BLOCKED,
                                    message: message,
                                    data: Number(login.blockTime) + login.lockTimeInMinutes * 60000
                                });
                            }));
                            break;
                        case idm_authentication_client_js_1.LoginResponseType.FAILED:
                        case idm_authentication_client_js_1.LoginResponseType.PRE_BLOCK:
                        case idm_authentication_client_js_1.LoginResponseType.UM_LOCK:
                            _this._openSubscriptions.push(_this.messageService
                                .getMessageWithPlaceholder(login.messageId, login.placeholders)
                                .subscribe(function (message) {
                                _this.resetLoginRequestState();
                                reject({
                                    loginStatus: login_status_enum_1.LoginStatus.FAILED,
                                    message: message,
                                    data: null
                                });
                            }));
                            break;
                        default:
                            throw new Error("Invalid login response. Provided response '" + login + "' does not belong: [SUCCESS, EXPIRED, FAILED]");
                    }
                })
                    .toPromise()
                    .catch(function (error) {
                    _this.handleError(error);
                    _this._openSubscriptions.push(_this.messageService
                        .getMessageWithPlaceholder(error.messageId, error.placeholders)
                        .subscribe(function (message) {
                        _this.resetLoginRequestState();
                        reject({
                            loginStatus: login_status_enum_1.LoginStatus.FAILED,
                            message: message,
                            data: null
                        });
                    }));
                });
            });
        }
        return this._loginRequestState;
    };
    LoginService.prototype.verify = function (code, verificationType) {
        var _this = this;
        if (this._loginRequestState === null) {
            this._loginRequestState = new Promise(function (resolve, reject) {
                _this.authenticationService
                    .verifyCode(code, verificationType)
                    .map(function (verified) {
                    if (verified) {
                        _this.router.navigate([_this.authenticationService.redirectUrl]).then(function () {
                            _this.resetLoginRequestState();
                            resolve({
                                loginStatus: login_status_enum_1.LoginStatus.SUCCESS,
                                message: null
                            });
                        });
                    }
                    else {
                        _this._openSubscriptions.push(_this.messageService
                            .getMessage(LoginService_1.VERIFICATION_CODE_INCORRECT_MESSAGE)
                            .subscribe(function (message) {
                            _this.resetLoginRequestState();
                            reject({
                                loginStatus: login_status_enum_1.LoginStatus.VERIFICATION_CODE_INCORRECT,
                                message: message
                            });
                        }));
                    }
                })
                    .toPromise()
                    .catch(function (error) {
                    _this.handleError(error);
                    _this._openSubscriptions.push(_this.messageService
                        .getMessageWithPlaceholder(error.messageId, error.placeholders)
                        .subscribe(function (message) {
                        _this.resetLoginRequestState();
                        reject({
                            loginStatus: login_status_enum_1.LoginStatus.FAILED,
                            message: message
                        });
                    }));
                });
            });
        }
        return this._loginRequestState;
    };
    LoginService.prototype.resend = function (verificationType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.authenticationService
                .resend(verificationType)
                .map(function (status) {
                _this.resetLoginRequestState();
                if (!status) {
                    reject({
                        loginStatus: login_status_enum_1.LoginStatus.FAILED,
                        message: null
                    });
                }
                else {
                    resolve({
                        loginStatus: login_status_enum_1.LoginStatus.SUCCESS,
                        message: null
                    });
                }
            })
                .toPromise()
                .catch(function (error) {
                _this.handleError(error);
            });
        });
    };
    LoginService.prototype.loginViaSAML = function () {
        var _this = this;
        this.applicationPropertiesService
            .getProperty(sso_config_1.SSOConfig.SSO_SERVICE_URL_KEY)
            .then(function (serviceUrl) {
            window.location.href =
                serviceUrl + sso_config_1.SSOConfig.SSO_LOGIN_URL +
                    '?' + sso_config_1.SSOConfig.SSO_HOME_URL_QUERY_PARAM + _this.getSAMLRedirectUrl() +
                    '&' + sso_config_1.SSOConfig.SSO_DEEP_URL_QUERY_PARAM + encodeURIComponent(_this.authenticationService.redirectUrl);
        })
            .catch(function (error) { return _this.handleError; });
    };
    LoginService.prototype.loginAsGuest = function () {
        var _this = this;
        this._openSubscriptions.push(this.authenticationService.loginAsGuest().subscribe(function (isLogged) {
            switch (isLogged.loginResponse) {
                case idm_authentication_client_js_1.LoginResponseType.SUCCESS:
                    _this.router.navigate([_this.authenticationService.redirectUrl]);
                    break;
                case idm_authentication_client_js_1.LoginResponseType.FAILED:
                    throw new Error("Something went wrong during the login process of guest user");
                default:
                    throw new Error("Invalid login response. Provided response \"" + isLogged + "\" does not belong: [SUCCESS, EXPIRED, FAILED]");
            }
        }, function (error) {
            _this.handleError(error);
        }));
    };
    LoginService.prototype.resetPassword = function () {
        this.router.navigateByUrl(LoginService_1.RESET_PASSWORD_URL);
    };
    LoginService.prototype.registration = function () {
        this.router.navigateByUrl(LoginService_1.REGISTRATION_URL);
    };
    LoginService.prototype.logout = function () {
        this.authenticationService.logout(true);
    };
    /**
     * Returns application home url.
     */
    LoginService.prototype.getSAMLRedirectUrl = function () {
        var homeUrl = window.location.origin + this.platformLocation.getBaseHrefFromDOM();
        if (homeUrl.endsWith('/')) {
            homeUrl = homeUrl.slice(0, -1);
        }
        return homeUrl;
    };
    /**
     * Handles errors
     * @param error
     * @returns {ErrorObservable}
     */
    LoginService.prototype.handleError = function (error) {
        var errMsg = error.message
            ? error.message
            : error.status
                ? error.status + " - " + error.statusText
                : 'Server error';
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    LoginService.prototype.resetLoginRequestState = function () {
        this._loginRequestState = null;
    };
    var LoginService_1;
    LoginService.VERIFICATION_MESSAGE = 'ui_shell_verification_message_containing_user_info';
    LoginService.VERIFICATION_CODE_INCORRECT_MESSAGE = 'ui_shell_verification_code_incorrect';
    LoginService.RESET_PASSWORD_URL = '/resetpassword';
    LoginService.REGISTRATION_URL = '/registration';
    LoginService = LoginService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [router_1.Router,
            idm_authentication_client_js_1.AuthenticationService,
            idm_message_language_service_client_js_1.MessageService,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            common_1.PlatformLocation])
    ], LoginService);
    return LoginService;
}());
exports.LoginService = LoginService;
//# sourceMappingURL=login.service.js.map